import './_jquery';

jQuery(function() {
  $('.partners-list__row-item__container__element__scheda-partner__tab').on('click', function() {
    let arrow_tab, scheda_body;

    arrow_tab = $(this).find('.arrow');
    scheda_body = $(this).next('.partners-list__row-item__container__element__scheda-partner__body');

    $(scheda_body).toggleClass('active');
    if ($(scheda_body).hasClass('active')) {
      $(arrow_tab).removeClass('right').addClass('down');
    } else {
      $(arrow_tab).removeClass('down').addClass('right');
    }
  });
});
